import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import * as dataActions from "../../data/rentals";

const prefix = "app/rental-dialog";

type State = { open: boolean; editRentalId: string | null };
const initialState: State = { open: false, editRentalId: null };

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {
    openRentalDialog(state) {
      state.open = true;
    },
    closeRentalDialog(state) {
      state.open = false;
    },
    openEditRentalDialog(state, action: PayloadAction<string>) {
      state.editRentalId = action.payload;
    },
    closeEditRentalDialog(state) {
      state.editRentalId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(dataActions.createRental.fulfilled, (state) => {
        state.open = false;
      })
      .addCase(dataActions.updateRental.fulfilled, (state) => {
        state.editRentalId = null;
      });
  },
});

export default slice.reducer;
export const {
  openRentalDialog,
  closeRentalDialog,
  openEditRentalDialog,
  closeEditRentalDialog,
} = slice.actions;
export const selectRentalDialogOpen = (state: {
  app: { rentalDialog: State };
}) => state.app.rentalDialog.open;
export const selectEditRentalId = (state: {
  app: { rentalDialog: State };
}) => state.app.rentalDialog.editRentalId;
